import { pdf } from "@react-pdf/renderer";
import templates from "../pdf-generation/index";

const convertSVGToPNG = async (svg) => {
  const img = new Image();
  const blob = new Blob([svg], {type: 'image/svg+xml'});
  const url = URL.createObjectURL(blob);
  
  return new Promise((resolve, reject) => {
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const scale = 3;
      const targetWidth = 930;
      const targetHeight = 700;
      
      // Maintain aspect ratio
      const aspectRatio = img.width / img.height;
      const width = Math.min(targetWidth, targetHeight * aspectRatio);
      const height = width / aspectRatio;
      
      canvas.width = width * scale;
      canvas.height = height * scale;
      const ctx = canvas.getContext('2d');
      
      // Center
      const xOffset = (targetWidth - width) / 2;
      const yOffset = (targetHeight - height) / 2;
      
      ctx.scale(scale, scale);
      ctx.drawImage(img, xOffset, yOffset, width, height);
      
      const dataUrl = canvas.toDataURL('image/png');
      URL.revokeObjectURL(url);
      resolve(dataUrl);
    };
    img.onerror = reject;
    img.src = url;
  });
};

const generatePDF = async (templateName, data, language) => {
  try {
    const template = templates[templateName];
    
    if (!template) {
      throw new Error();
    }

    const blob = await pdf(template({ data, language })).toBlob();
    return { data: blob };
  } catch (error) {
    throw new Error();
  }
};

export {
  convertSVGToPNG,
  generatePDF
}